import {
  AfterViewInit,
  Component,
  inject,
  input,
  Input,
  model,
  OnDestroy,
  OnInit,
  Renderer2,
  signal,
  ViewChild
} from '@angular/core';
import {NgbActiveModal, NgbModal, NgbPagination} from "@ng-bootstrap/ng-bootstrap";
import {FormsModule, NgForm} from "@angular/forms";
import {BKK_PROVINCE_ID, LABEL_HMAIN_HOST, markInvalidControlsAsDirtyAndTouched, SN, SP} from "../../../app.constants";
import {CommonModule} from "@angular/common";
import {SubDistrictAutocompleteComponent} from "../subdistrict-autocomplete/sub-district-autocomplete.component";
import {NgSelectModule} from "@ng-select/ng-select";
import {DigitOnlyModule} from "@uiowa/digit-only";
import {CustomErrorComponent} from "../../commons/custom-error.component";
import {MastercupResource} from "../../../service/MastercupResource";
import {
  DistrictDto,
  MastercupDto,
  MastercupSearchParam,
  Page,
  Province,
  ProvinceDto,
  SubDistrict,
  SubDistrictDto,
  UserData
} from "../../../../generated-model/model";
import {NotFoundComponent} from "../../not-found/not-found.component";
import {SharedCommonModule} from "../../commons/shared-common.module";
import {UserDataService} from "../../../security/user-data.service";
import {MastercupStatusComponent} from "../mastercup-status/mastercup-status.component";
import {SelectMastercupProvinceComponent} from "../select-mastercup-province/select-mastercup-province.component";
import {SelectMastercupDistrictComponent} from "../select-mastercup-district/select-mastercup-district.component";
import {
  SelectMastercupSubdistrictComponent
} from "../select-mastercup-subdistrict/select-mastercup-subdistrict.component";
import {SelectMooComponent} from "../select-moo/select-moo.component";
import {MastercupSearchOption} from "../../../pages/secure/register/mastercup-search-option";

@Component({
  selector: 'app-select-mastercup',
  templateUrl: './select-mastercup-search.component.html',
  standalone: true,
  styles: [
    `
      .custom-modal-content .modal-content {
        overflow: auto;
      }

      .custom-modal-content .modal-content .modal-body {
        //background-color: aliceblue;
      }

      .selectable-mastercup {
        cursor: pointer;
      }

      tbody tr td {
        vertical-align: middle;
      }
    `
  ],
  imports: [
    CommonModule,
    SubDistrictAutocompleteComponent,
    NgSelectModule,
    DigitOnlyModule,
    CustomErrorComponent,
    FormsModule,
    NgbPagination,
    NotFoundComponent,
    SharedCommonModule,
    MastercupStatusComponent,
    SelectMastercupProvinceComponent,
    SelectMastercupDistrictComponent,
    SelectMastercupSubdistrictComponent,
    SelectMooComponent
  ]
})
export class SelectMastercupSearchComponent implements OnInit, AfterViewInit, OnDestroy {

  protected readonly labelHmainHost = LABEL_HMAIN_HOST;
  @ViewChild('form', {static: true}) public form: NgForm;
  @Input('subDistrict') public subDistrict: SubDistrictDto;
  renderer = inject(Renderer2);
  activeModal = inject(NgbActiveModal);
  modalService = inject(NgbModal);
  mastercupResource = inject(MastercupResource);
  userDataService = inject(UserDataService);
  pageData: Page<MastercupDto> = {size: 10, number: 0};
  moo = model<string>(undefined);
  user = signal<UserData>(undefined);

  restrictProvince = input<Province>(undefined);
  selectedSubDistrict = model<SubDistrict>(undefined);
  selectedDistrict = model<DistrictDto>(undefined);
  selectedProvince = model<ProvinceDto>(undefined);
  selectedMoo = model<string>(undefined);
  options = input<MastercupSearchOption>({fetchAll: true});

  constructor() {
  }

  onProvinceChange() {
    this.selectedDistrict.set(undefined);
    this.selectedSubDistrict.set(undefined);
    this.selectedMoo.set(undefined);
  }

  onDistrictChange() {
    this.selectedSubDistrict.set(undefined);
    this.selectedMoo.set(undefined);
  }

  onSubDistrictChange() {
    this.selectedMoo.set(undefined);
  }

  ngOnInit(): void {
    this.userDataService.getCurrent()
      .subscribe(e => {
        this.user.set(e);
      });
  }

  search(page: number = 1) {
    let formValid = this.updateFormAndValidity(this.form);
    if (formValid) {
      let searchParam: MastercupSearchParam = {};
      searchParam.catm = this.selectedSubDistrict()?.catm;
      searchParam.districtId = this.selectedDistrict()?.code;
      searchParam.moo = this.selectedMoo();
      searchParam.hcode3Level = this.options().hcode3Level || true;
      this.mastercupResource.searchByCatm(searchParam, page - 1, this.pageData.size)
        .subscribe(e => {
          this.pageData = e;
        });
    }
  }

  updateFormAndValidity(form: NgForm): boolean {
    if (!form.valid) {
      markInvalidControlsAsDirtyAndTouched(form)
    }
    return form.valid
  }

  submit() {
    let formValid = this.updateFormAndValidity(this.form);
    if (formValid) {
      // this.activeModal.close(requestVendor);

    } else {
      console.log('invalid form')
      // this.activeModal.close(requestVendor);
    }
  }

  select(mastercup: MastercupDto) {
    this.activeModal.close(mastercup);
  }

  ngAfterViewInit(): void {
  }

  close() {
    this.activeModal.dismiss()
  }

  ngOnDestroy(): void {
    // if (this.loadingSubject && !this.loadingSubject.closed) {
    //   this.loadingSubject.unsubscribe();
    // }
  }

  provinceBkk(subDistrict: SubDistrictDto) {
    let provinceId = subDistrict?.district?.province?.id;
    if (!provinceId) {
      return false;
    }
    return provinceId == BKK_PROVINCE_ID || provinceId.startsWith(SN) || provinceId.startsWith(SP);
  }

  clear() {

  }
}
